<template lang="pug">
.flex.flex-wrap.gap-2
  .min-w-36(:aria-label="$t('protocol')")
    el-select(
      :model-value="linkValue.protocol",
      :disabled="props.disabled",
      @update:model-value="updateProtocol"
    )
      el-option(
        v-for="protocol in protocols",
        :key="protocol",
        :label="`${protocol}${protocol.startsWith('http') ? '://' : ':'}`",
        :value="protocol"
      )
  el-input(
    :model-value="linkValue.path",
    :aria-label="$t('path')",
    :placeholder="$t('path')",
    :disabled="props.disabled",
    @update:model-value="updatePath"
  )
  el-input(
    :model-value="linkValue.label",
    :aria-label="$t('label')",
    :placeholder="$t('label')",
    :disabled="props.disabled",
    @update:model-value="updateLabel"
  )
</template>

<script setup lang="ts">
import { computed } from "vue";
import { type LinkPropertyValue } from "@shared/services/twinManagement";

const props = defineProps<{
  modelValue?: LinkPropertyValue;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: LinkPropertyValue];
}>();

const protocols = ["http", "https", "mailto", "sivas"] as const;

const linkValue = computed<LinkPropertyValue>(() => {
  return (
    props.modelValue ?? {
      type: "link",
      protocol: "https",
      path: "",
      label: "",
    }
  );
});

function updateProtocol(protocol: LinkPropertyValue["protocol"]) {
  emit("update:modelValue", { ...linkValue.value, protocol });
}

function updatePath(path: string) {
  emit("update:modelValue", { ...linkValue.value, path });
}

function updateLabel(label: string) {
  emit("update:modelValue", { ...linkValue.value, label });
}
</script>
